// The ONE marker for "we are working on it" (Pavel 5.8.: the abstract blue
// shape next to "Uz na tom pracujeme" said nothing - "strasne divnej tvar,
// kteremu vubec nerozumim". Whenever the team is working, the interface shows
// the pulsing avatar it already uses for the training step, nothing else).
//
// One component, three sizes, one meaning:
//   rail  - 30px marker inside the progress rail
//   card  - 44px beside a heading in a status card
//   stage - 130px hero on a whole waiting screen
//
// Rail and stage keep their historical class names on purpose: the rail styles,
// the live measuring harness (artifacts/fixr5/rail-probe.mjs) and the visual
// guards query `rail-training-*`, and the stage composition (breathing shells
// behind a dissolving face, Pavel 24.7. "aby to melo dusi") is `training-orb`.
// New working states use the compact `card` size; none of them invents its own
// icon again.

export type WorkingAvatarSize = "rail" | "card" | "stage";

export function WorkingAvatar(props: {
  size?: WorkingAvatarSize;
  profilePhotoUrl?: string | null;
  className?: string;
}) {
  const size = props.size ?? "card";
  // The client's own face becomes the Buddy while we work (meeting 24.7.:
  // "bude pulsovat jeho avatar"); the generic orb covers clients with no photo.
  const photo = props.profilePhotoUrl || null;
  const extra = props.className ? ` ${props.className}` : "";

  if (size === "rail") {
    return (
      <span
        className={`progress-mark rail-training-orb rail-marker-training${photo ? "" : " rail-training-orb-empty"}${extra}`}
        data-marker-state="training"
        data-working-avatar="rail"
        aria-hidden="true"
      >
        {photo
          ? <img className="rail-training-photo" src={photo} alt="" />
          : <span className="rail-training-neutral" />}
      </span>
    );
  }

  if (size === "stage") {
    return (
      <div className={`training-orb${extra}`} data-working-avatar="stage" aria-hidden="true">
        <span /><span /><span />
        <img
          className={photo ? "training-orb-face training-orb-photo" : "training-orb-face"}
          src={photo || "/buddy-orb.png"}
          alt=""
        />
      </div>
    );
  }

  return (
    <span className={`working-avatar${extra}`} data-working-avatar="card" aria-hidden="true">
      {photo
        ? <img className="working-avatar-photo" src={photo} alt="" />
        : <span className="working-avatar-orb" />}
    </span>
  );
}
